export default "__VITE_ASSET__DOs4v1jn__"